import React from 'react'
import styled from 'styled-components'
import { Modal, Stack, Title, Box, Image } from '@mantine/core'
import { Button } from '../../components'
import DoneImg from './icons/done.png'
import ErrorImg from './icons/error.png'
import WarnImg from './icons/warn.png'
import { useMedia } from '../../hooks'
import { Media } from '../../theme'
const imgMap = {
  done: DoneImg,
  error: ErrorImg,
  warn: WarnImg,
}
const Wrap = styled.div`
  /* background: linear-gradient(180deg, #ffffff 60%, #ffefe8 100%); */
  h3 {
    color: #333;
    font-weight: bold !important;
  }
  p {
    color: #666666;
    text-align: center;
    a {
      color: currentColor;
      :hover {
        color: ${p => p.theme.color.secondary};
        text-decoration: underline;
      }
    }
    b {
      color: #333;
    }
  }
  button {
    min-width: 180px;
    margin-top: 40px;
  }
  ${Media.phone`
    h3 {
      font-size: .3rem !important;
    }
    p {
      font-size: .24rem;
    }
    button {
      margin-top: .4rem;
    }
  `}
`
export function ConfirmModal({ type = 'done', title, desc, opened, onClose, id }) {
  const isMobile = useMedia()
  return (
    <>
      <Modal
        size={isMobile ? 300 : 400}
        opened={opened}
        styles={{ body: { borderRadius: '8px', background: 'linear-gradient(180deg, #ffffff 60%, #ffefe8 100%)' } }}
        onClose={onClose}
        centered
        withCloseButton={false}
      >
        <Wrap>
          <Stack align='center' wrap gap={0} py={{ base: 12, md: 24 }}>
            <Image w={{ base: 40, md: 70 }} src={imgMap[type]} />
            <Title pt={{ base: 12, md: 24 }} pb={12} fz={20} order={3} color='#333'>
              {title}
            </Title>
            <Box px={{ base: 0, md: 10 }} dangerouslySetInnerHTML={{ __html: desc }}></Box>
            <Button size='large' id={id} onClick={onClose}>
              OK
            </Button>
          </Stack>
        </Wrap>
      </Modal>
    </>
  )
}
